import { SourceType } from 'module/api/filter/types';
import { Translate, useTranslate } from 'module/hooks/use-translation';
import { FieldType } from 'module/types/filter-field/field/field';
import {
  DateField,
  FilterableField,
  NumberField,
  TextField,
} from 'module/types/filter-field/field/filterable-field';
import { useMemo } from 'react';

export enum PeopleDefaultColumnFields {
  Name = 'name',
  LastEngagedOn = 'lastEngagedOn',
  RecentRisks = 'recentRisks',
  RecentOpportunities = 'recentOpportunities',
}
export const NoneSortableFields: string[] = [
  PeopleDefaultColumnFields.RecentRisks,
  PeopleDefaultColumnFields.RecentOpportunities,
];

export const NonEditableFields: string[] = [
  PeopleDefaultColumnFields.Name,
  PeopleDefaultColumnFields.LastEngagedOn,
  PeopleDefaultColumnFields.RecentRisks,
  PeopleDefaultColumnFields.RecentOpportunities,
];
export const HoverableFields: string[] = [
  PeopleDefaultColumnFields.Name,
  PeopleDefaultColumnFields.RecentRisks,
  PeopleDefaultColumnFields.RecentOpportunities,
];

const nameField = (translate: Translate): TextField => ({
  fieldName: PeopleDefaultColumnFields.Name,
  fieldLabel: translate('account.people.fields.name'),
  type: FieldType.Text,
  fieldId: -1000,
  private: false,
  customField: false,
  sourceType: SourceType.User,
});

const lastEngagedOnField = (translate: Translate): DateField => ({
  fieldName: PeopleDefaultColumnFields.LastEngagedOn,
  fieldLabel: translate('account.people.fields.last_engaged_on'),
  type: FieldType.Date,
  fieldId: -1001,
  private: false,
  sourceType: SourceType.User,
});

const recentRisksField = (translate: Translate): NumberField => ({
  fieldName: PeopleDefaultColumnFields.RecentRisks,
  fieldLabel: translate('account.people.fields.recent_risks'),
  type: FieldType.Number,
  fieldId: -1002,
  private: false,
  sourceType: SourceType.User,
});

const recentOpportunitiesField = (translate: Translate): NumberField => ({
  fieldName: PeopleDefaultColumnFields.RecentOpportunities,
  fieldLabel: translate('account.people.fields.recent_opportunities'),
  type: FieldType.Number,
  fieldId: -1003,
  private: false,
  sourceType: SourceType.User,
});

export const useStaticColumnFields = (): FilterableField[] => {
  const translate = useTranslate();

  return useMemo(
    () => [
      nameField(translate),
      lastEngagedOnField(translate),
      recentRisksField(translate),
      recentOpportunitiesField(translate),
    ],
    [translate],
  );
};
